export const ar = {
  sidebar: {
    sections: {
      myWork: "عملي",
      teamInbox: "صندوق الفريق",
      byTrigger: "حسب الزناد",
      management: "الإدارة",
      settings: "الإعدادات",
    },
    items: {
      myDay: "يومي",
      mySnoozed: "المؤجلة لدي",
      myArchived: "المؤرشفة لدي",
      unassigned: "غير معيّنة",
      needsAttention: "تحتاج اهتمام",
      confirmationNeeded: "تحتاج تأكيد",
      openDraftOrders: "طلبات مسودة مفتوحة",
      checkoutRecovery: "استرداد السلة",
      customers: "العملاء",
      reports: "التقارير",
      storeConnection: "ربط المتجر",
      triggerRules: "قواعد التشغيل",
      usersTeams: "المستخدمون والفرق",
      syncHealth: "حالة المزامنة",
      preferences: "التفضيلات",
      billing: "الاشتراك",
    },
  },
  topbar: {
    profileSettings: "إعدادات الملف الشخصي",
    logout: "تسجيل الخروج",
    logoutConfirmTitle: "تسجيل الخروج",
    logoutConfirmDescription: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    logoutFailed: "فشل تسجيل الخروج. حاول مرة أخرى.",
    logoutConfirm: "نعم",
    loggingOut: "جارٍ تسجيل الخروج...",
  },
  localeSelector: {
    language: "اللغة",
  },
} as const;
